import { Activity } from "@/models/Activity";
import PaginatedResponse from "@/models/PaginatedResponse";

export const ActivityRequest = (argActivity) => {
  let activity = argActivity.copy();

  if (!activity.id) {
    delete activity.id;
  }

  if (activity.category) {
    activity.category = activity.category.id;
  }

  // Avoid sending empty string to backend for date values
  if (activity.deadline_date === "") {
    activity.deadline_date = null;
  }

  if (activity.start_date === "") {
    activity.start_date = null;
  }

  if (activity.done_date === "") {
    activity.done_date = null;
  }

  if (activity.questionnaire) {
    activity.questionnaire = activity.questionnaire.id;
  }

  if (activity.info) {
    activity.info = activity.info.id;
  }

  if (activity.protocol) {
    activity.protocol = activity.protocol.id;
  }

  if (activity.creator) {
    activity.creator = activity.creator.id;
  }

  if (activity.responsible) {
    activity.responsible = activity.responsible.id;
  }

  if (activity.controller) {
    activity.controller = activity.controller.id;
  }

  if (activity.tags) {
    for (var i = 0; i < activity.tags.length; i++) {
      activity.tags[i] = activity.tags[i].id;
    }
  }

  return activity;
};

export const ActivityResponse = (activity) => {
  return new Activity(activity);
};

export const ActivitiesResponse = (activities) => {
  return activities.map((p) => ActivityResponse(p));
};

export const PaginatedActivitiesResponse = (data) => {
  let response = new PaginatedResponse(data);
  response.results = response.results.map((i) => ActivityResponse(i));
  return response;
};
